import { motion } from "framer-motion";

const Contacto = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 p-12 gap-12">
            <motion.div
                className="text-justify"
                initial={{ x: -200, opacity:0}}
                animate={{ x:0, opacity:1 }}
                transition={{duration: 1}}
                viewport={{ once: false }}
            >
                <h2 className="text-red-600 font-semibold text-3xl">Contáctanos para conocer más detalles</h2>
                <p className="text-gray-500">
                    ¡Llámanos y cotiza!
                        <br/> <br/>
                    Calle 47 Poniente, Col. Prados agua azul,
                        <br/> <br/>
                    Puebla pue. C.P. 72430
                        <br/> <br/>
                    loyalty.1512@gmail.com
                        <br/> <br/>
                    222 471 3255
                </p>
            </motion.div>
            <motion.div
                initial={{ x: 200, opacity:0}}
                animate={{ x:0, opacity:1 }}
                transition={{duration: 1}}
                viewport={{ once: false }}
                className="h-full"
            >
                <div className="bg-gray-700 h-full rounded-lg p-8 gap-4">
                    <h2 className="text-white font-bold">
                        Queremos saber más cosas sobre usted
                    </h2>
                    <p className="text-gray-300">
                        Envíenos sus datos y nos pondremos en contacto con usted para concertar una cita para hablar.
                    </p>
                    <form className="flex flex-col gap-6 mt-4">
                        {["Nombre", "Email", "Teléfono"].map((label, i) => (
                            <div key={i} className="relative">
                                <input
                                    type={label === "Email" ? "email" : label === "Teléfono" ? "tel" : "text"}
                                    placeholder={label}
                                    className="w-full bg-transparent border-b border-white text-white placeholder-gray-300 py-2 px-1 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-none transition-all duration-200"
                                />
                            </div>
                        ))}

                        <button
                            type="submit"
                            className="bg-gray-400 hover:bg-red-600 text-white font-semibold py-2 rounded transition-all"
                        >
                            Enviar
                        </button>
                    </form>
                </div>
            </motion.div>
        </div>
    );
};

export default Contacto;